import type { Notification } from 'entities/notification';

import { isNotificationNew } from './is-notification-new';
import { isNotificationRead } from './is-notification-read';

export function isNotificationUrgent(notification: Notification): boolean {
  return isNotificationNew(notification) && !isNotificationRead(notification);
}
